module.exports = __webpack_public_path__ + "img/paymentmethods.994a6f7c.png";